import create from "zustand";

export const useClient = create((set) => ({
  client: null,

  setClient: (client) => {
    set({ client });
  },
}));
